import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { map, sortBy } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { printf, toText, join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Machine_getNameOrCode, strIContains } from "../Shared/Shared.js";
import { uncurry2, int32ToString, createObj, compareArrays } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Divider, Checkbox, TableBody, Link, TableCell, TableRow, Table, TableContainer, Typography } from "@mui/material";
import { now, compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { SnackError, condTooltip } from "../ViewHelpers.js";
import { API_Customer_Agreement, API_Customer_Responsible } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CustomerServiceAgreement_$reflection, Account_$reflection } from "../Shared/ApiDataTypes.js";
import { array_type, obj_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { bind, some, unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Links_CustomerPath } from "../Utils.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ComponentsModule_Chip_Level, Components_Chip_51BC9844 } from "../Components/Chip.js";
import { toDateOnlyStr } from "../Locale.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { Components_Shortcut_Z74A6BA73 } from "../Components/Shortcut.js";
import Receipt from "@mui/icons-material/Receipt";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import Build from "@mui/icons-material/Build";
import Phone from "@mui/icons-material/Phone";
import People from "@mui/icons-material/People";
import { MuiXHelpers_createElement } from "../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Components_ActivityCalendar_Z2E686B84 } from "../Components/Activities/ActivityCalendar.js";
import { Tickets_StatusCard_Z2E686B84 } from "../Components/Tickets/StatusCard.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Components_OrderStatusCard_Z2E686B84 } from "../Components/OrderStatusCard.js";
import { Tickets_WarrantyStatusCard_Z2E686B84 } from "../Components/Tickets/WarantyStatusCard.js";

function Customer_DrawMachines_Z5E02542(customer_DrawMachines_Z5E02542InputProps) {
    let machines, contains;
    const customer = customer_DrawMachines_Z5E02542InputProps.customer;
    const groupId = customer_DrawMachines_Z5E02542InputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState("");
    const filter = patternInput[0];
    const machines_1 = sortBy((m_1) => [m_1.Removed != null, m_1.Name], (machines = customer.Machines, isNullOrWhiteSpace(filter) ? machines : ((contains = ((str_1) => strIContains(filter, str_1)), machines.filter((m) => {
        if (contains(m.Name) ? true : contains(m.Code)) {
            return true;
        }
        else {
            return contains(m.SerialNumber);
        }
    })))), {
        Compare: compareArrays,
    });
    const xs_1 = toList(delay(() => append(singleton(createElement("div", {
        style: {
            maxWidth: 320 + "px",
        },
        children: createElement(Components_Searchbar_25F45B5E, {
            placeholder: ctx.Locale.t("CustomerSite.Overview.SearchMachine"),
            onChange: (ev) => {
                patternInput[1](ev.target.value);
            },
        }),
    })), delay(() => {
        let elements_3, elements_2, children;
        return (customer.Machines.length === 0) ? singleton(MuiHelpers_createElement(Typography, [["variant", "subtitle1"], ["children", ctx.Locale.t("Customer.NoMachines")]])) : singleton(MuiHelpers_createElement(TableContainer, [["sx", {
            overflowY: "scroll",
            maxHeight: 300 + "px",
            paddingTop: 10 + "px",
        }], (elements_3 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_2 = [(children = singleton_1(map((machine) => {
            let elements, elems, child;
            const machineNameMissing = isNullOrWhiteSpace(machine.Name);
            const machineNameOrCode = Machine_getNameOrCode({
                code: machine.Code,
                name: machine.Name,
            });
            let isRemoved;
            const matchValue = machine.Removed;
            if (matchValue != null) {
                const removed = matchValue;
                try {
                    isRemoved = (compare(removed, now()) < 0);
                }
                catch (matchValue_1) {
                    isRemoved = false;
                }
            }
            else {
                isRemoved = false;
            }
            return MuiHelpers_createElement(TableRow, [["style", createObj(toList(delay(() => (isRemoved ? singleton(["backgroundColor", "#f1f1f1"]) : empty()))))], (elements = [MuiHelpers_createElement(TableCell, [(elems = [(child = MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customer.Id), "machine", int32ToString(machine.Id)]), 1)], ["underline", "none"], ["children", machineNameOrCode]]), condTooltip(`*${ctx.Locale.t("Services.MissingMachineName")}`, machineNameMissing, child))], ["children", reactApi.Children.toArray(Array.from(elems))])]), MuiHelpers_createElement(TableCell, [["style", {
                maxWidth: 80,
                textAlign: "right",
            }], ["children", isRemoved ? ctx.Locale.t("Removed") : ""]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
        }, machines_1)), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Customer_ContactPointCard_5A5EA313(customer_ContactPointCard_5A5EA313InputProps) {
    let elems_6, elems_5, elements_4, children_3, children, children_1, children_2;
    const accountOpt = customer_ContactPointCard_5A5EA313InputProps.accountOpt;
    const customerId = customer_ContactPointCard_5A5EA313InputProps.customerId;
    const key = customer_ContactPointCard_5A5EA313InputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const initial = accountOpt == null;
    patternInput = reactApi.useState(initial);
    const patternInput_1 = reactApi.useState(accountOpt);
    const accountOpt_1 = patternInput_1[0];
    reactApi.useEffect(() => {
        let properties_2;
        if (accountOpt_1 == null) {
            const url = API_Customer_Responsible(customerId);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(option_type(Account_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(option_type(Account_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                if (res.tag === 0) {
                    patternInput_1[1](res.fields[0]);
                }
                else {
                    console.error(some("[Customer] Error fetching resp.: %o"), res.fields[0]);
                }
                patternInput[1](false);
            });
        }
    }, []);
    if (patternInput[0]) {
        return defaultOf();
    }
    else if (accountOpt_1 != null) {
        const account = accountOpt_1;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 15 + "px",
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 600 + "px",
            maxWidth: 700 + "px",
        }], (elems_6 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.MyPointOfContact")]]), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], (elems_5 = [MuiHelpers_createElement(Table, [(elements_4 = [(children_3 = ofArray([(children = ofArray([MuiHelpers_createElement(TableCell, [["children", "Navn"]]), MuiHelpers_createElement(TableCell, [["children", `${account.FirstName} ${account.LastName}`]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(TableCell, [["children", "Telefonnummer"]]), MuiHelpers_createElement(TableCell, [["children", `+${account.PhoneCC} ${account.Phone}`]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_2 = ofArray([MuiHelpers_createElement(TableCell, [["children", "Epost"]]), MuiHelpers_createElement(TableCell, [["children", MuiHelpers_createElement(Link, [["href", `mailto:${account.Email}`], ["children", account.Email]])]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]))]), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
    }
    else {
        return defaultOf();
    }
}

export function Customer_Overview_Z5E02542(customer_Overview_Z5E02542InputProps) {
    let elems_2, elems_24, elems_4, elems_3, elems_7, elems_6, $key3292924F, elems_23, elems_13, elems_16, elems_15, value_190, elems_14, elems_22, elems_21;
    const customer = customer_Overview_Z5E02542InputProps.customer;
    const groupId = customer_Overview_Z5E02542InputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState([]);
    const setCustomerAgreement = patternInput[1];
    const customerAgreement = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setErr = patternInput_1[1];
    const patternInput_2 = defaultArg(map_1((sess) => [sess.IsAdmin ? true : sess.IsSuperAdmin, sess.IsPtg, sess.TicketAccess], ctx.Session), [false, false, false]);
    const hasTicketAccess = patternInput_2[2];
    const isCustomer = !patternInput_2[0] && !patternInput_2[1];
    const subpageUrl = (arg) => RouterModule_encodeParts(ofArray(Links_CustomerPath(groupId, customer.Id, arg)), 1);
    const economyUrl = RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customer.Id), "economy" + RouterModule_encodeQueryString(singleton_1(["invoices", toString_1(true)]))]), 1);
    const orderServiceHref = subpageUrl(isCustomer ? "tickets" : "activity-plan");
    const dependencies = [customer.Id];
    reactApi.useEffect(() => {
        const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => {
            let url, pr_1, decoder, data_1, caseStrategy_2, extra_2;
            return ((url = API_Customer_Agreement(customer.Id), (pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(CustomerServiceAgreement_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(CustomerServiceAgreement_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    setCustomerAgreement([]);
                    setErr(ctx.Locale.t("Customer.CouldNotFind"));
                    return Promise.resolve();
                }
                else {
                    setCustomerAgreement(res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_2.then();
    }, dependencies);
    const toggleServiceButton = MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"], ["sx", {
        p: 0.5,
    }], ["disabled", isCustomer], ["checked", customer.EnableServices], ["onChange", (e) => {
        const enabled = e.target.checked;
        console.debug("Toggle services enabled checkbox");
    }]]);
    let customerData;
    const title = (text) => createElement("div", {
        style: {
            flexGrow: 1,
            maxWidth: 40 + "ch",
        },
        children: MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", text]]),
    });
    const value_27 = (child) => createElement("div", {
        style: {},
        children: child,
    });
    const row = (children) => createElement("div", {
        style: {
            display: "flex",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
    customerData = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
        width: 100 + "%",
    }], (elems_2 = toList(delay(() => append(singleton(row([title(ctx.Locale.t("Customer.CustomerNo")), value_27(`#${customer.Number}`)])), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => {
        let elems_1;
        return append(singleton(row([title(ctx.Locale.t("Customer.Agreements")), value_27(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 0.5 + "rem",
        }], (elems_1 = ((customerAgreement.length === 0) ? [createElement(Components_Chip_51BC9844, {
            key: "no-agreement-chip",
            $key: "no-agreement-chip",
            primary: ctx.Locale.t("Customer.NoAgreements"),
            enabled: true,
            colorLevel: new ComponentsModule_Chip_Level(3, []),
        })] : map((agreement) => {
            const dateStr = defaultArg(bind((d_6) => {
                try {
                    return toDateOnlyStr(ctx.DateFnsLocale, parse(d_6));
                }
                catch (matchValue_1) {
                    return undefined;
                }
            }, agreement.EndDate), ctx.Locale.t("Customer.UnknownDate"));
            const $key3AD15BB1 = `agreement-chip-${agreement.Id}`;
            return createElement(Components_Chip_51BC9844, {
                key: $key3AD15BB1,
                $key: $key3AD15BB1,
                primary: `${agreement.AgreementName} – ${agreement.CompanyName} (${dateStr})`,
                enabled: true,
                colorLevel: new ComponentsModule_Chip_Level(1, []),
            });
        }, customerAgreement)), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))])), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => append(singleton(row([title(ctx.Locale.t("Customer.NumMachines")), value_27(customer.Machines.length)])), delay(() => (!isCustomer ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(row([title("Service og vedlikeholdsplan"), value_27(toggleServiceButton)])))) : empty())))))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    const xs_29 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_1[0]),
        dismiss: () => {
            setErr(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        gap: 40 + "px ",
    }], (elems_24 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_4 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.WhatDoYouWantToDo")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 30 + "px",
    }], (elems_3 = toList(delay(() => append(singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.MyFGas"),
        lower: ctx.Locale.t("CustomerSite.Overview.Accounting"),
        href: subpageUrl("gas-report"),
        icon: (props_11) => {
            const props_13 = createObj(props_11);
            return react.createElement(Receipt, props_13);
        },
    })), delay(() => append(singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.SeeMy"),
        lower: ctx.Locale.t("CustomerSite.Overview.Invoice"),
        href: economyUrl,
        icon: (props_14) => {
            const props_16 = createObj(props_14);
            return react.createElement(ReceiptLong, props_16);
        },
    })), delay(() => append((customer.EnableServices && (!isCustomer ? true : hasTicketAccess)) ? singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("Order"),
        lower: ctx.Locale.t("CustomerSite.Overview.service"),
        href: orderServiceHref,
        icon: (props_17) => {
            const props_19 = createObj(props_17);
            return react.createElement(Build, props_19);
        },
    })) : empty(), delay(() => append(singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("Pages.Contact"),
        lower: ctx.Locale.t("PTG"),
        href: RouterModule_encodeParts(ofArray(["contact", int32ToString(customer.Id)]), 1),
        icon: (props_20) => {
            const props_22 = createObj(props_20);
            return react.createElement(Phone, props_22);
        },
    })), delay(() => singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.Help"),
        lower: ctx.Locale.t("CustomerSite.Overview.Kundeweb"),
        href: RouterModule_encodeParts(singleton_1("helpdesk"), 1),
        icon: (props_23) => {
            const props_25 = createObj(props_23);
            return react.createElement(People, props_25);
        },
    })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 40 + "px",
    }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 600 + "px",
        maxWidth: 700 + "px",
    }], (elems_6 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.CustomerData")]]), createElement("div", {
        className: join(" ", ["bordered-container"]),
        children: reactApi.Children.toArray([customerData]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), ($key3292924F = toText(printf("customer-%i-contact-card"))(customer.Id), createElement(Customer_ContactPointCard_5A5EA313, {
        key: $key3292924F,
        $key: $key3292924F,
        customerId: customer.Id,
        accountOpt: unwrap(customer.Responsible),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 40 + "px",
    }], (elems_23 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 40 + "px",
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: 600 + "px",
    }], (elems_13 = toList(delay(() => {
        let elems_9, elems_8;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 15 + "px",
        }], (elems_9 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.MachineOverview")]]), createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
            width: 100 + "%",
        }], (elems_8 = [createElement(Customer_DrawMachines_Z5E02542, {
            groupId: groupId,
            customer: customer,
        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
            let elems_12, children_6, elems_10, elems_11;
            const matchValue_2 = customer.Memo;
            if (matchValue_2 != null) {
                const m = matchValue_2;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 15 + "px",
                }], (elems_12 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", "Kundenotat"]]), (children_6 = ofArray([createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                }], (elems_10 = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", ctx.Locale.t("Customer.MemoDesc")]])], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    width: 100 + "%",
                    minHeight: 20 + "ch",
                    border: (((1 + "px ") + "solid") + " ") + "var(--grey)",
                    borderRadius: 15 + "px",
                }], (elems_11 = [createElement("p", {
                    style: {
                        whiteSpace: "pre-wrap",
                        fontSize: 0.85 + "rem",
                        padding: ((5 + "px ") + 10) + "px",
                    },
                    children: m,
                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))]), createElement("div", {
                    children: reactApi.Children.toArray(Array.from(children_6)),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: 320 + "px",
    }], (elems_16 = [MuiHelpers_createElement(Typography, [["sx", {
        maxWidth: 320 + "px",
    }], ["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.UpcomingEvents")]]), createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {}], (elems_15 = [MuiXHelpers_createElement(LocalizationProvider, [(value_190 = AdapterDateFns, ["dateAdapter", value_190]), (elems_14 = [createElement(Components_ActivityCalendar_Z2E686B84, {
        groupId: groupId,
        customerId: customer.Id,
    })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 200 + "px",
        minWidth: 200 + "px",
        maxWidth: 800 + "px",
    }], (elems_22 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Ticket.Status.Status")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 15 + "px",
    }], (elems_21 = toList(delay(() => {
        let elems_17;
        return append(hasTicketAccess ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 15 + "px",
            minWidth: 185 + "px",
        }], (elems_17 = [createElement(Tickets_StatusCard_Z2E686B84, {
            groupId: groupId,
            customerId: customer.Id,
        }), createElement(Components_Button_Z1043B8E, {
            text: ctx.Locale.t("CustomerSite.Overview.TicketOverview"),
            onClick: (_arg_4) => {
                RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customer.Id), "tickets"]), 1, 1);
            },
            startIcon: (props_48) => {
                const props_50 = createObj(props_48);
                return react.createElement(ArrowForward, props_50);
            },
            small: true,
            sx: some({
                alignSelf: "flex-end",
            }),
        })], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))) : empty(), delay(() => {
            let elems_19, elems_18;
            return append(singleton(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                display: "flex",
                flexDirection: "column",
                gap: 15 + "px",
                minWidth: 185 + "px",
            }], (elems_19 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Orders.Orders")]]), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 10 + "px",
            }], (elems_18 = [createElement(Components_OrderStatusCard_Z2E686B84, {
                groupId: groupId,
                customerId: customer.Id,
            })], ["children", reactApi.Children.toArray(Array.from(elems_18))])])))], ["children", reactApi.Children.toArray(Array.from(elems_19))])])))), delay(() => {
                let elems_20;
                return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 15 + "px",
                    minWidth: 185 + "px",
                }], (elems_20 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("CustomerSite.Overview.DeviationWarranties")]]), createElement(Tickets_WarrantyStatusCard_Z2E686B84, {
                    groupId: groupId,
                    customerId: customer.Id,
                })], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_21))])])))], ["children", reactApi.Children.toArray(Array.from(elems_22))])])))], ["children", reactApi.Children.toArray(Array.from(elems_23))])])))], ["children", reactApi.Children.toArray(Array.from(elems_24))])])))];
    return react.createElement(react.Fragment, {}, ...xs_29);
}

